import { Link } from "react-router-dom";
import { CATALOG, fmt, productPath } from "@/data/catalog";
import { mediaUrl as M } from "@/data/pdpMedia";
import { Reveal, AddToCartButton, Overline } from "@/components/common/ui";
import { ValueStrip } from "@/components/home/Strips";

const ORDER = ["single", "serum", "cleanser"];

export default function Shop() {
  return (
    <div data-testid="shop-page" className="bg-[#FFFCFA]">
      <header className="border-b border-[#F2E8E6] bg-white py-20 text-center md:py-28">
        <Overline>The Collection</Overline>
        <h1 className="mt-4 font-display text-5xl font-light text-[#2C2B2C] sm:text-7xl">Shop Aura Glow</h1>
        <p className="mx-auto mt-5 max-w-xl px-6 text-base font-light text-[#8A7F86]">
          Our signature LED mask, curated bundles and the rituals that complete your glow, all with free express shipping.
        </p>
      </header>

      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12">
        <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {ORDER.map((sku, i) => {
            const p = CATALOG[sku];
            return (
              <Reveal key={sku} delay={(i % 3) * 0.08} className="group flex flex-col rounded-[2rem] border border-[#F2E8E6] bg-[#FFFCFA]">
                <Link to={productPath(sku)} className="hover-zoom relative overflow-hidden">
                  {p.soldOut ? (
                    <span className="absolute right-4 top-4 z-10 bg-[#8A7F86] px-3 py-1 text-[0.6rem] uppercase tracking-widest text-[#FFFCFA]">Sold Out</span>
                  ) : (
                    p.badge && <span className="absolute right-4 top-4 z-10 bg-[#232222] px-3 py-1 text-[0.6rem] uppercase tracking-widest text-[#FFFCFA]">{p.badge}</span>
                  )}
                  <img src={M(`shop_${sku}`)} data-media-slot={`shop_${sku}`} data-media-type="image" alt={p.name} className={`h-80 w-full object-cover ${p.soldOut ? "opacity-70 grayscale-[35%]" : ""}`} />
                </Link>
                <div className="flex flex-1 flex-col p-7">
                  <span className="text-[0.6rem] uppercase tracking-[0.2em] text-[#FBC4A8]">{p.type}</span>
                  <Link to={productPath(sku)}><h2 className="mt-2 font-display text-2xl text-[#2C2B2C] hover:text-[#FBC4A8]">{p.name}</h2></Link>
                  <p className="mt-1.5 text-sm font-light text-[#8A7F86]">{p.subtitle}</p>
                  <div className="mt-4 flex items-baseline gap-3">
                    <span className="font-display text-2xl text-[#2C2B2C]">{fmt(p.price)}</span>
                    {p.compareAt > p.price && (
                      <span className="text-sm text-[#8A7F86] line-through">{fmt(p.compareAt)}</span>
                    )}
                  </div>
                  <div className="mt-6">
                    {p.soldOut ? (
                      <button disabled data-testid={`shop-soldout-${sku}`}
                        className="flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-full border border-[#E5DAD3] bg-[#F5EFEA] py-3.5 text-xs font-semibold uppercase tracking-[0.16em] text-[#9A8E88]">
                        Sold Out
                      </button>
                    ) : (
                      <AddToCartButton sku={sku} label="Add to Bag" variant="outline" className="w-full" testid={`shop-add-${sku}`} />
                    )}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
      <ValueStrip />
    </div>
  );
}
